/* eslint-disable no-console */
<template>
  <div class="edit_box">
    <!-- <el-button class="edit_button" type="info" @click="setisDetail()" plain>{{
      parentData.isDetail ? "编辑" : "取消编辑"
    }}</el-button> -->
    <!-- <el-col :span="12">
          <el-form-item label="通信地址" prop="areaList">
            <el-cascader v-model="form.areaList" :options="parentData.areaOptions" :props="{ value: 'countyCode', label: 'countyName', children: 'children' }" clearable />
          </el-form-item>
        </el-col> -->
    <!-- <el-col :span="12">
          <el-form-item label="住址" prop="homeAddress">
            <el-input v-model="form.homeAddress" placeholder="请输入住址" clearable />
          </el-form-item>
        </el-col> -->
    <!-- <el-col v-if="reportProvinceName=='jiangsu'" :span="12">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="form.sex" placeholder="请选择性别" clearable>
              <el-option :value="1" label="男" />
              <el-option :value="2" label="女" />
            </el-select>
          </el-form-item>
        </el-col> -->
    <!-- <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入联系方式" autocomplete="off" clearable disabled />
          </el-form-item>
        </el-col> -->
    <!-- 解决自动填充问题 -->
    <!-- <el-col :span="12">
          <el-form-item label="密码" prop="password">
            <el-input type="password" style="position: fixed; bottom: -9999px;" />
            <el-input v-model="form.password" type="password" autocomplete="new-password" placeholder="请输入密码，默认abcd1234" clearable />
          </el-form-item>
        </el-col> -->
    <!-- <el-col :span="12">
          <el-form-item label="工作单位" prop="workCompany">
            <el-input v-model="form.workCompany" placeholder="请输入工作单位" clearable />
          </el-form-item>
        </el-col> -->
    <div class="content_wrap">
      <div class="line1">
        <div class="line1_left">{{ title }}</div>
        <!-- <div class="refuse_info" v-if="form.authMsg">
        <span class="refuse_title">上次驳回意见：</span>
        <span class="refuse_msg"> {{ form.authMsg }}</span>
      </div> -->
        <!-- <div class="line1_right" @click="setisDetail">
        {{ parentData.isDetail ? "编辑" : "取消编辑" }}
      </div> -->
      </div>
      <div class="form_wrap">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="140px"
          :disabled="title === '详情'"
        >
          <div class="mode_box">
            <div class="card_info">身份证信息</div>

            <!-- 必填 -->
            <el-row style="padding-right:80px;">
              <el-col :span="8">
                <el-form-item label="姓名">
                  <el-input v-model="form.name" placeholder="姓名" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="出生年月" prop="birth">
                  <el-input
                    v-model="form.birth"
                    placeholder="请输入出生年月"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="性别" prop="sex">
                  <el-select
                    v-model="form.sex"
                    placeholder="请选择性别"
                    clearable
                  >
                    <el-option :value="1" label="男" />
                    <el-option :value="2" label="女" />
                  </el-select>
                </el-form-item>
              </el-col>
              <!--   <el-col :span="8">
              <el-form-item label="性别" prop="sex">
                <el-input
                  v-model="form.sex"
                  placeholder="请输入性别"
                  clearable
                />
              </el-form-item>
            </el-col>-->
              <el-col :span="8">
                <el-form-item label="手机号码" prop="phone">
                  <el-input
                    v-model="form.phone"
                    placeholder="请输入手机号码"
                    clearable
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="民族" prop="nationality">
                  <el-input
                    v-model="form.nationality"
                    placeholder="请输入民族"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="签发机关" prop="idCardIssuingOrgan">
                  <el-input
                    v-model="form.idCardIssuingOrgan"
                    placeholder="请输入签发机关"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="住址" prop="homeAddress">
                  <el-input
                    autosize
                    type="textarea"
                    v-model="form.homeAddress"
                    placeholder="请输入住址"
                    clearable
                    maxlength="90"
                  />
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item
                  label="公民身份证号码"
                  prop="identificationNumber"
                >
                  <el-input
                    v-model="form.identificationNumber"
                    placeholder="请输入公民身份证号码"
                    clearable
                  />
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="身份证有效期" prop="idCardDueDate">
                  <el-date-picker
                    v-model="form.idCardDueDate"
                    :class="form.hasDueDate ? 'disabledhide' : ''"
                    type="date"
                    value-format="yyyy-MM-dd"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item label="长期" label-width="60px">
                  <el-checkbox
                    v-model="form.hasDueDate"
                    @change="
                      value => {
                        this.$set(
                          form,
                          'idCardDueDate',
                          value ? '9999-12-31' : ''
                        );
                      }
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传证件">
                  <!-- parentData.isDetail -->
                  <ImgReview
                    lebal="实际承运人身份证人像面照片"
                    :src="form.identificationImg"
                    error="未上传"
                    v-if="false"
                  />
                  <ImgUpload
                    :upload-config="{
                      lebal: '实际承运人身份证人像面照片',
                      prefix: 'identification',
                      form: form,
                      suffix: 'Img'
                    }"
                    :parent-data="form"
                    :required="!!form.identificationImg"
                    v-else
                  />
                  <ImgReview
                    lebal="实际承运人身份证国徽面照片"
                    :src="form.identificationBackImg"
                    error="未上传"
                    v-if="false"
                  />
                  <ImgUpload
                    :upload-config="{
                      lebal: '实际承运人身份证国徽面照片',
                      prefix: 'identificationBack',
                      form: form,
                      suffix: 'Img'
                    }"
                    :parent-data="form"
                    :required="!!form.identificationBackImg"
                    v-else
                  />
                  <!-- <ImgReview lebal="实际承运人半身照" :src="form.driverImg" error="未上传" />

            <ImgReview lebal="机动车驾驶证照片" :src="form.driverLicenseImg" error="未上传" />
            <ImgReview lebal="道路运输从业资格证照片" :src="form.workLicenseImg" error="未上传" />
            <ImgReview lebal="安全责任险照片" :src="form.safeDutyInsureImg" error="未上传" /> -->
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- :class="{ pitch_on: !!form.driverIsup }" -->
          <div class="mode_box">
            <div class="card_info">其他证件信息</div>
            <div class="card_type_title">机动车驾驶证</div>
            <el-row style="padding-right:80px;">
              <el-col :span="8">
                <el-form-item label="驾驶证号" prop="driverLicense">
                  <el-input
                    v-model="form.driverLicense"
                    placeholder="请输入机动车驾驶证号"
                    clearable
                    class="report_box"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="档案编号" prop="fileNo">
                  <el-input
                    v-model="form.fileNo"
                    placeholder="请输入档案编号"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="发证机关"
                  prop="driverIssuingOrganizations"
                >
                  <el-input
                    v-model="form.driverIssuingOrganizations"
                    placeholder="请输入机动车驾驶证发证机关"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="准驾类型" prop="vehicleClass">
                  <el-select
                    v-model="form.vehicleClass"
                    placeholder="请选择准驾类型"
                    clearable
                    class="report_box"
                  >
                    <el-option
                      v-for="item in parentData.vehicleTypeAllowList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code"
                    />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="8">
                <el-form-item label="有效期自" prop="driverLicenseFromDate">
                  <el-date-picker
                    class="report_box"
                    v-model="form.driverLicenseFromDate"
                    type="date"
                    placeholder="请选择机动车驾驶证有效期开始日期"
                    value-format="yyyy-MM-dd"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="初次领证日期" prop="firstIssueDate">
                  <el-date-picker
                    v-model="form.firstIssueDate"
                    type="date"
                    placeholder="请输入机动车驾驶证初次领证日期"
                    value-format="yyyy-MM-dd"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="有效期至" prop="driverLicenseDueDate">
                  <el-date-picker
                    class="report_box"
                    v-model="form.driverLicenseDueDate"
                    :class="form.hasDriverDueDate ? 'disabledhide' : ''"
                    type="date"
                    placeholder="请选择机动车驾驶证有效期结束日期"
                    value-format="yyyy-MM-dd"
                    clearable
                    :disabled="form.hasDriverDueDate"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="2">
                <el-form-item label="长期" label-width="60px">
                  <el-checkbox
                    v-model="form.hasDriverDueDate"
                    @change="
                      value => {
                        this.$set(
                          form,
                          'driverLicenseDueDate',
                          value ? '9999-12-31' : ''
                        );
                      }
                    "
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传证件">
                  <ImgReview
                    lebal="机动车驾驶证照片"
                    :src="form.driverLicenseImg"
                    error="未上传"
                    v-if="false"
                  />
                  <ImgUpload
                    :upload-config="{
                      lebal: '机动车驾驶证照片',
                      prefix: 'driverLicense',
                      form: form,
                      suffix: 'Img'
                    }"
                    :parent-data="form"
                    :required="!!form.driverLicenseImg"
                    v-else
                  />
                  <ImgReview
                    lebal="机动车驾驶证副页照片"
                    :src="form.driverLicenseBackImg"
                    error="未上传"
                    v-if="false"
                  />
                  <ImgUpload
                    :upload-config="{
                      lebal: '机动车驾驶证副页照片',
                      prefix: 'driverLicenseBack',
                      form: form,
                      suffix: 'Img'
                    }"
                    :parent-data="form"
                    :required="!!form.driverLicenseBackImg"
                    v-else
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <div class="card_type_title" style="margin-top:15px;">
              道路运输从业资格证
            </div>
            <el-row style="padding-right:80px;">
              <el-col :span="13">
                <el-form-item label="资格证号" prop="workLicense">
                  <template slot="label">
                    资格证号
                    <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="注:总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000"
                    placement="top"
                  >
                    <i
                      class="el-icon-question"
                      style="margin-left: 4px;cursor: pointer;"
                    ></i>
                  </el-tooltip> -->
                  </template>
                  <el-input
                    v-model="form.workLicense"
                    placeholder="请输入道路运输从业资格证号"
                    clearable
                    class="report_box"
                  />
                  <div class="remarks">
                    注:总质量4.5吨及以下普通货运车辆从事普通货物运输经营的驾驶员可填驾驶员身份证前6位+000000000000
                  </div>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="12">
          <el-form-item
            label="道路运输从业资格证准驾车型"
            prop="approvedDriving"
          >
            <el-input
              v-model="form.approvedDriving"
              placeholder="请输入道路运输从业资格证准驾车型"
              clearable
            />
          </el-form-item>
        </el-col> -->
              <el-col :span="11">
                <el-form-item label="资格类别" prop="qualificationCategory">
                  <el-input
                    v-model="form.qualificationCategory"
                    placeholder="请输入道路运输从业资格证从业资格类别"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="13">
                <el-form-item
                  label="初次领证日期"
                  prop="initialCertificationDate"
                >
                  <el-date-picker
                    v-model="form.initialCertificationDate"
                    type="date"
                    placeholder="初次领证日期"
                    value-format="yyyy-MM-dd"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="到期日期" prop="workLicenseDueDate">
                  <el-date-picker
                    v-model="form.workLicenseDueDate"
                    type="date"
                    placeholder="请选择道路运输从业资格证到期日期"
                    value-format="yyyy-MM-dd"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="上传证件">
                  <ImgReview
                    lebal="道路运输从业资格证照片"
                    :src="form.workLicenseImg"
                    error="未上传"
                    v-if="false"
                  />
                  <ImgUpload
                    :upload-config="{
                      lebal: '道路运输从业资格证照片',
                      prefix: 'workLicense',
                      form: form,
                      suffix: 'Img'
                    }"
                    :parent-data="form"
                    :required="!!form.workLicenseImg"
                    v-else
                  />
                  <ImgReview
                    lebal="道路运输从业资格证照片(副页)"
                    :src="form.workLicenseDeputyImg"
                    error="未上传"
                    v-if="false"
                  />
                  <ImgUpload
                    :upload-config="{
                      lebal: '道路运输从业资格证照片(副页)',
                      prefix: 'workLicenseDeputy',
                      form: form,
                      suffix: 'Img'
                    }"
                    :parent-data="form"
                    :required="!!form.workLicenseDeputyImg"
                    v-else
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="refuse_wrap" v-if="newRefuseArr.length">
            <div class="refuse_title">驳回记录</div>
            <div class="refuse_content">
              <div
                v-for="item in newRefuseArr"
                :key="item.name"
                class="refuse_item_wrap"
              >
                <div class="refuse_name">{{ item.name }}:</div>
                <span class="refuse_value">{{ item.value }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="mode_box">
          <div class="card_info">驳回记录</div>
        </div> -->
          <!-- <div :class="{ pitch_on: !!form.roadIsup }"></div> -->
          <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <ImgReview
              lebal="道路运输经营许可证照片"
              :src="form.roadPermitNumberImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
          <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="道路经营许可证业户名称" prop="roadPermitName">
            <el-input
              v-model="form.roadPermitName"
              placeholder="请输入道路经营许可证业户名称"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col v-if="reportProvinceName == 'liaoning'" :span="12">
          <el-form-item
            label="道路经营业户社会信用代码"
            prop="businessUniformSocialCreditCode"
          >
            <el-input
              v-model="form.businessUniformSocialCreditCode"
              placeholder="请输入道路经营业户社会信用代码"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输经营许可证号" prop="roadPermitNumber">
            <el-input
              v-model="form.roadPermitNumber"
              placeholder="请输入道路运输经营许可证号"
              clearable
            />
            <div class="remarks">
              注:总质量4.5吨及以下普通货运车辆的可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输经营许可证经营范围" prop="businessScope">
            <el-input
              v-model="form.businessScope"
              placeholder="请输入道路运输经营许可证经营范围"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输经营许可证证件有效期"
            prop="periodValidity"
          >
            <el-input
              v-model="form.periodValidity"
              placeholder="请输入道路运输经营许可证证件有效期"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row> -->

          <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="车辆证件">
            <ImgReview
              lebal="车辆行驶证正页照片"
              :src="form.vehicleLicenseImg"
              error="未上传"
            />
            <ImgReview
              lebal="车辆行驶证副页照片"
              :src="form.vehicleLicenseDeputyPageImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
      </el-row> -->
          <!-- 车辆证件 -->
          <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="号牌号码" prop="licenseNumber">
            <el-input
              v-model="form.licenseNumber"
              placeholder="请输入号牌号码"
              clearable
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="车辆类型" prop="classificationCode">
            <el-select
              v-model="form.classificationCode"
              placeholder="请选择车辆类型"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleClassificationList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col v-if="form.driverType === 0" :span="12">
          <el-form-item
            :label="
              form.isHasTrailer == 1 ? '车头整备质量(kg)' : '车辆总质量(kg)'
            "
            prop="totalWeight"
          >
            <el-input
              v-model="form.vehicleVO.totalWeight"
              type="number"
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="form.driverType === 0" :span="12">
          <el-form-item
            :label="
              form.isHasTrailer == 1 ? '准牵引总质量(kg)' : '核定载质量(kg)'
            "
            prop="loadWeight"
          >
            <el-input
              v-model="form.vehicleVO.loadWeight"
              type="number"
              placeholder="请输入"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="外廓尺寸mm">
            <el-col :span="8">
              <el-form-item class="dif" prop="length">
                <el-input
                  v-model="form.length"
                  placeholder="请输入车辆长度"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="dif" prop="width" label-width="10px">
                *
                <el-input
                  v-model="form.width"
                  style="padding-left: 6px"
                  placeholder="请输入车辆宽度"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item class="dif" prop="height" label-width="10px">
                *
                <el-input
                  v-model="form.height"
                  style="padding-left: 6px"
                  placeholder="请输入车辆高度"
                  clearable
                />mm
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col v-if="reportProvinceName == 'jiangsu'" :span="12">
          <el-form-item label="车轴数" prop="axlenum">
            <el-input
              v-model="form.axlenum"
              placeholder="请输入车轴数"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="form.driverType === 0" label="车辆所有人">
            <el-input
              v-model="form.owner"
              placeholder="请输入车辆所有人"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证档案编号" prop="vehicleLicense">
            <el-input
              v-model="form.vehicleLicense"
              placeholder="请输入车辆行驶证档案编号"
              clearable
            />
            <div class="remarks">
              注:行驶证若不存在档案编号可填车籍地6位行政区域代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证到期日期" prop="vehicleLicenseDueDate">
            <el-input v-model="form.vehicleLicenseDueDate" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Brand and Model" prop="brandModel">
            <el-input v-model="form.brandModel" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发动机号码" prop="engineNo">
            <el-input v-model="form.engineNo" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆使用性质" prop="useCharacter">
            <el-input
              v-model="form.useCharacter"
              placeholder="请输入车辆车辆使用性质"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="核定载人数" prop="approvedPassengers">
            <el-input v-model="form.approvedPassengers" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="整备质量" prop="unladenMass">
            <el-input v-model="form.unladenMass" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆识别代号" prop="vin">
            <el-input
              v-model="form.vin"
              placeholder="请输入车辆识别代号"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="车辆行驶证发证机关"
            prop="vehicleIssuingOrganizations"
          >
            <el-input
              v-model="form.vehicleIssuingOrganizations"
              placeholder="请输入车辆行驶证发证机关"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证注册日期" prop="registerDate">
            <el-date-picker
              v-model="form.registerDate"
              type="date"
              placeholder="请选择车辆行驶证注册日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆行驶证发证日期" prop="issueDate">
            <el-date-picker
              v-model="form.issueDate"
              type="date"
              placeholder="请选择车辆行驶证发证日期"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="24">
          <el-form-item label="挂车证件">
            <ImgReview
              v-if="compTrailer"
              lebal="挂车行驶证正页照片"
              :src="form.trailerVehicleLicenseImg"
              error="未上传"
            />
            <ImgReview
              v-if="compTrailer"
              lebal="挂车行驶证副页照片"
              :src="form.trailerVehicleLicenseDeputyPageImg"
              error="未上传"
            />
            <ImgReview
              v-if="compTrailer"
              lebal="挂车照片"
              :src="form.trailerVehicleImg"
              error="未上传"
            />
            <ImgReview
              v-if="compTrailer"
              lebal="挂车道路运输证照片"
              :src="form.trailerRoadTransportCertificateImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车车牌号" prop="trailerNum">
            <el-input
              v-model="form.trailerNum"
              placeholder="请输入挂车车牌号"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车车牌颜色" prop="trailerLicenseColor">
            <el-select
              v-model="form.trailerLicenseColor"
              placeholder="请选择挂车车牌颜色"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleLicenseColorList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="挂车车辆类型" prop="trailerClassificationCode">
            <el-select
              v-model="form.trailerClassificationCode"
              placeholder="请选择挂车车辆类型"
              clearable
              filterable
            >
              <el-option
                v-for="item in parentData.vehicleClassificationList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车总质量(kg)">
            <el-input v-model="form.trailerTotalWeight" />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车核定载质量(kg)">
            <el-input v-model="form.trailerLoadWeight" />
          </el-form-item>
        </el-col>
        <el-col v-if="compTrailer" :span="12">
          <el-form-item label="挂车道路运输证号" prop="trailerRoadTransport">
            <el-input
              v-model="form.trailerRoadTransport"
              placeholder="请输入车辆道路运输证号"
            />
            <div class="remarks">
              总质量4.5吨及以下普通货运车辆可填车籍地6位行政区代码+000000
            </div>
          </el-form-item>
        </el-col>
      </el-row> -->
          <!--
      <el-row>
        <el-col :span="24">
          <el-form-item label="上传证件">
            <ImgReview
              lebal="道路运输证照片"
              :src="form.roadTransportCertificateImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
      </el-row> -->

          <!-- <el-row> -->
          <!-- <el-col :span="12">
          <el-form-item
            label="车辆道路运输证号"
            prop="roadTransportCertificateNumber"
          >
            <el-input
              v-model="form.roadTransportCertificateNumber"
              placeholder="请输入车辆道路运输证号"
              clearable
            />
            <div class="remarks">
              总质量4.5吨及以下普通货运车辆可填车籍地6位行政区代码+000000
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="经营许可证号(道路运输证)"
            prop="roadTransportPermitNumber"
          >
            <el-input v-model="form.roadTransportPermitNumber" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输证经济类型" prop="economicType">
            <el-input v-model="form.economicType" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输证车辆类型"
            prop="typeRoadTransportVehicle"
          >
            <el-input v-model="form.typeRoadTransportVehicle" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="道路运输证车辆吨位(吨)" prop="shippingTon">
            <el-input v-model="form.shippingTon" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输证经营范围"
            prop="businessScopeTransportation"
          >
            <el-input v-model="form.businessScopeTransportation" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="道路运输证到期日期"
            prop="roadTransportCertificateDate"
          >
            <el-input v-model="form.roadTransportCertificateDate" />
          </el-form-item>
        </el-col> -->
          <!-- <el-col v-if="reportProvinceName=='liaoning'" :span="12">
          <el-form-item label="车辆道路运输证字" prop="roadTransportCertificateWord">
            <el-input v-model="form.roadTransportCertificateWord" placeholder="请输入车辆道路运输证字" clearable />
          </el-form-item>
        </el-col>

        <el-col v-if="hasTaxOpen" :span="12">
          <el-form-item label="车辆实际所有人" prop="realOwner">
            <el-input v-model="form.realOwner" placeholder="请输入" clearable />
          </el-form-item>
        </el-col> -->
          <!-- </el-row> -->
          <!-- 车队长增加 -->
          <!-- <el-row v-if="form.driverType === 1"> -->
          <!--  v-if="isCompanyMode" -->
          <!-- <el-col :span="12">
          <el-form-item label="统一社会信用代码" prop="businessLicenseNumber">
            <el-input
              v-model="form.businessLicenseNumber"
              placeholder="请输入统一社会信用代码"
              :disabled="true"
            />
          </el-form-item>
        </el-col> -->
          <!-- </el-row> -->
          <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="是否挂靠车辆" prop="isLinked">
            <el-select v-model="form.isLinked" placeholder="请选择" clearable>
              <el-option v-for="item in isLinkedOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="hasTaxOpen" :span="12">
          <el-form-item label="车辆品牌" prop="brand">
            <el-input v-model="form.brand" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否挂车" prop="isHasTrailer">
            <el-select v-model="form.isHasTrailer" placeholder="请选择" clearable>
              <el-option v-for="item in isHasTrailerOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </el-col>

      </el-row> -->

          <!-- 选填 -->
          <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="其他上传">
            <ImgReview
              lebal="实际承运人半身照"
              :src="form.driverImg"
              error="未上传"
            />
            <ImgReview lebal="车辆照片" :src="form.vehicleImg" error="未上传" />
            <ImgReview
              lebal="安全责任险照片"
              :src="form.safeDutyInsureImg"
              error="未上传"
            />
          </el-form-item>
        </el-col>
      </el-row> -->

          <!-- <el-row>
        <el-col :span="12">
          <el-form-item label="车牌颜色" prop="vehicleLicenseColor">
            <el-select
              v-model="form.vehicleLicenseColorName"
              placeholder="请选择车牌颜色"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleLicenseColorList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车辆能源类型" prop="vehicleEnergyType">
            <el-select
              v-model="form.vehicleEnergyTypeName"
              placeholder="请选择车辆能源类型"
              clearable
            >
              <el-option
                v-for="item in parentData.vehicleEnergyTypeList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
        </el-form>
      </div>
    </div>

    <!-- 审核按钮 funcRefuse-->
    <el-row v-if="review" class="_btns">
      <el-button
        type="text"
        style="margin-right:15px;font-size:16px;"
        @click="saveEdit"
        >保存</el-button
      >
      <el-button class="reject" type="danger" @click="changeShowRefuse">
        审核驳回
      </el-button>
      <el-button class="adopt" type="primary" @click="submitEdit">
        审核通过
      </el-button>
      <!-- v-if="!parentData.isDetail" -->

      <!-- <el-button class="adopt" type="primary" @click="submitEdit">
        保存编辑
      </el-button> -->
    </el-row>
    <br />
    <el-dialog
      title="驳回意见"
      :visible.sync="showRefuse"
      append-to-body
      modal-append-to-body
      width="600px"
      class="clearfix"
    >
      <el-form ref="formData" :model="form">
        <el-form-item prop="authMsg">
          <div class="refuse_box">
            <div class="refuse_item" v-for="item in refuseArr" :key="item.name">
              <div class="refuse_title">{{ item.name }}:</div>
              <el-input
                v-model="item.value"
                placeholder="请输入内容"
              ></el-input>
            </div>
          </div>
          <!-- <el-input
            v-model="authMsg"
            placeholder="请输入驳回意见"
            type="textarea"
            maxlength="100"
            show-word-limit
            :autosize="{ minRows: 4 }"
            clearable
          /> -->
        </el-form-item>
      </el-form>
      <div class="clearfix">
        <el-button @click="funcRefuse" type="primary" style="float: right;"
          >确认驳回</el-button
        >
      </div>
    </el-dialog>
    <!-- -->
  </div>
</template>
<script>
import {
  isTaxOpen,
  authInfo,
  driverAuth,
  updateDriverTeam
} from "@/api/driver.js";
import ImgReview from "@/components/ImgReview";
import ImgUpload from "@/components/ImgUpload";
import request from "@/utils/request";
import { insuranceType } from "@/api/orderform";
export default {
  name: "DriverEdit",
  components: {
    ImgReview,
    ImgUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false,
          areaOptions: [],
          vehicleTypeAllowList: [],
          vehicleClassificationList: [],
          vehicleLengthList: [],
          vehicleWidthList: [],
          vehicleHighList: [],
          vehicleTonnageList: [],
          vehicleLicenseColorList: [],
          mode: "detail"
        };
      }
    },
    title: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      newRefuseArr: [],
      refuseArr: [
        {
          name: "身份证",
          value: "",
          type: "d01"
        },
        {
          name: "驾驶证",
          value: "",
          type: "d02"
        },
        {
          name: "从业资格证",
          value: "",
          type: "d03"
        },
        {
          name: "其他原因",
          value: "",
          type: "d04"
        }
      ],
      rules: {
        identificationNumber: [
          { required: true, message: "请输入公民身份证号码", trigger: "blur" }
        ],
        idCardDueDate: [
          { required: true, message: "请选择身份证有效期", trigger: "change" }
        ],
        driverLicense: [
          { required: true, message: "请输入驾驶证号", trigger: "blur" }
        ],
        fileNo: [
          { required: true, message: "请输入档案编号", trigger: "blur" }
        ],
        vehicleClass: [
          { required: true, message: "请选择准驾类型", trigger: "change" }
        ],
        driverLicenseFromDate: [
          { required: true, message: "请选择驾驶证有效期自", trigger: "change" }
        ],
        driverLicenseDueDate: [
          { required: true, message: "请选择有效期至", trigger: "change" }
        ],
        workLicense: [
          { required: true, message: "请输入资格证号", trigger: "blur" }
        ],
        qualificationCategory: [
          { required: true, message: "请输入从业资格类别", trigger: "blur" }
        ],
        workLicenseDueDate: [
          { required: true, message: "请选择到期日期", trigger: "change" }
        ]
      },
      showRefuse: false, //驳回意见弹窗
      showExtra: true,
      ctmsShow: true,
      hasTaxOpen: "",
      authMsg: "",
      otherItems: true,
      linkageInvalid: true,
      submitShow: true,
      reportProvinceName: "",
      code: "",
      form: {
        isHasTrailer: 0,
        birth: "", //  出生年月
        gender: "", //性别
        phone手机号码: "", //
        nationality: "", //民族
        issuingAuthority: "", //签发机关
        address: "", //住址
        idCard: "" //公民身份证号码
      },
      // 挂车
      isHasTrailerOptions: [
        { label: "否", value: 0 },
        { label: "是", value: 1 }
      ],
      // 挂靠车辆
      isLinkedOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      // 是否清分
      isShareOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }]
    };
  },
  computed: {
    compTrailer() {
      return this.form.isHasTrailer === 1 ? true : false;
    },
    review() {
      return this.parentData.model === "review" ? true : false;
    }
  },
  watch: {},
  created() {
    this.reportProvinceName = this.reportProvince();
    this.form = {
      vehicleVO: {}
    };
    isTaxOpen().then(res => {
      this.hasTaxOpen = res.data;
    });
  },
  methods: {
    ficationImgSuccess(e) {
      console.log("实际承运人身份证人像面照片", e);
    },
    setisDetail() {
      this.parentData.isDetail = !this.parentData.isDetail;
    },
    getDriver(code) {
      this.code = code;
      authInfo({ code: code }).then(response => {
        console.log("response", response);
        let vehicleVO = response.data.vehicleVO || {};
        this.form = Object.assign({}, response.data, vehicleVO);
        this.newRefuseArr = this.refuseArr
          .map(item => {
            const found = this.form.authMsgList.find(obj =>
              obj.hasOwnProperty(item.type)
            );
            return {
              ...item,
              value: found ? found[item.type] : item.value
            };
          })
          .filter(item => item.value !== "");
        console.log("newRefuseArr", this.newRefuseArr);
        this.$set(this.form, "address", response.data.homeAddress);
        this.$set(
          this.form,
          "issuingAuthority",
          response.data.idCardIssuingOrgan
        );
        this.$set(this.form, "birth", response.data.birth);

        this.authMsg = response.data.authMsg || "";
        this.$set(this.form, "areaList", []);
        if (
          this.form.provinceCode &&
          this.form.cityCode &&
          this.form.countyCode
        ) {
          this.form.areaList.push(
            this.form.provinceCode,
            this.form.cityCode,
            this.form.countyCode
          );
        }
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.$set(
          this.form,
          "hasDriverDueDate",
          this.form.driverLicenseDueDate == "9999-12-31"
        );
      });
      // request({
      //   url: `/ntocc-basic-api/driver/${code}`,
      //   method: "get",
      // }).then((response) => {
      //   let vehicleVO = response.data.vehicleVO || {};
      //   this.form = Object.assign({}, response.data, vehicleVO);
      //   this.authMsg = response.data.authMsg || "";
      //   this.$set(this.form, "areaList", []);
      //   if (
      //     this.form.provinceCode &&
      //     this.form.cityCode &&
      //     this.form.countyCode
      //   ) {
      //     this.form.areaList.push(
      //       this.form.provinceCode,
      //       this.form.cityCode,
      //       this.form.countyCode
      //     );
      //   }
      //   this.$set(
      //     this.form,
      //     "hasDueDate",
      //     this.form.idCardDueDate == "9999-12-31"
      //   );
      //   this.$set(
      //     this.form,
      //     "hasDriverDueDate",
      //     this.form.driverLicenseDueDate == "9999-12-31"
      //   );
      // });
      insuranceType(this.instype).then(response => {
        this.locationSourceoptions = response.data.records;
      });
    },
    // 同意审核
    funcSubmit() {
      const rLoading = this.openLoading();
      driverAuth({ code: this.code, authStatus: 3 }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.$emit("fatherMethods");
      });
    },
    // submitEdit() {
    //   this.$confirm("确认审核通过吗", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   })
    //     .then(() => {
    //       this.submitEditSure();
    //     })
    //     .catch(() => {});
    // },
    // 保存编辑
    saveEdit() {
      updateDriverTeam(this.form).then(response => {
        console.log("保存api==========", response);
        if (response.status == 0) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
        }
      });
    },
    // 审核通过
    submitEdit() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.$message.warning("请完善必填项");
          return;
        }
        updateDriverTeam(this.form).then(response => {
          this.funcSubmit();

          // this.$message({
          //   message: "编辑成功",
          //   type: "success"
          // });
        });
      });
    },
    changeShowRefuse() {
      this.showRefuse = true;
    },
    // 拒绝审核
    funcRefuse() {
      let isEmpty = this.refuseArr.every(item => {
        return item.value == "";
      });
      if (isEmpty) {
        this.$message.warning("请输入驳回原因");
        return;
      }
      const result = this.refuseArr
        .filter(item => item.value)
        .map(item => ({ [item.type]: item.value.replace(/[；;]/g, "") }));
      console.log("===========", this.refuseArr, result);
      // if (this.authMsg.trim() == "") {
      //   this.$message.warning("请输入驳回原因");
      //   return;
      // }
      const rLoading = this.openLoading();
      driverAuth({
        code: this.code,
        authStatus: 2,
        authMsgList: JSON.stringify(result)
        // authMsg: this.authMsg
      }).then(response => {
        rLoading.close();
        this.$message({
          message: response.msg,
          type: "success"
        });
        this.showRefuse = false;
        this.refuseArr.forEach(item => {
          item.value = "";
        });
        this.$emit("fatherMethods");
      });
      // request({
      //   url: `/ntocc-basic-api/driver/updateAuthStatus`,
      //   method: "post",
      //   params: {

      //   },
      // })
    }
  }
};
</script>
<style lang="scss" scoped>
.content_wrap {
  height: calc(100vh - 197px);
  overflow: auto;
}
.refuse_box {
  padding-right: 30px;
  .refuse_item {
    display: flex;
    margin-bottom: 20px;
    .refuse_title {
      width: 150px;
      font-weight: bold;
      text-align: right;
      margin-right: 10px;
    }
  }
}
.report_box {
  // 突出要上报数据的输入框，加入明显的红色外阴影
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px rgba(12, 125, 231, 0.7);
}
.refuse_info {
  margin-right: 40px;
  .refuse_title {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
  }
  .refuse_msg {
    font-size: 17px;
    color: #333333;
  }
}
.refuse_wrap {
  padding: 20px;
  border: 1px solid #f0f3f8;
  border-radius: 10px 10px 10px 10px;
  margin-bottom: 20px;
  .refuse_title {
    font-size: 17px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 15px;
  }
  .refuse_content {
    font-size: 17px;
    color: #333333;
    .refuse_item_wrap {
      margin-bottom: 5px;
      display: flex;
      .refuse_name {
        // font-weight: bold;
        margin-right: 10px;
        width: 100px;
        text-align: right;
      }
      .refuse_value {
      }
    }
  }
}
.mode_box {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #f0f3f8;
  margin-top: 45px;
  overflow: hidden;
  margin-bottom: 18px;
  .card_info {
    width: 100%;
    height: 62px;
    line-height: 62px;
    background: #f0f3f8;
    border-radius: 0px 0px 0px 0px;
    font-weight: bold;
    font-size: 18px;
    color: #1169e9;
    padding-left: 15px;
    margin-bottom: 43px;
  }
}

._btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 30px;
  margin-right: 15px;
  .reject {
    width: 160px;
    height: 46px;
    background: #ef4141;
    border-radius: 4px 4px 4px 4px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    margin-right: 16px;
  }
  .adopt {
    width: 160px;
    height: 46px;
    background: #4186ef;
    border-radius: 4px 4px 4px 4px;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
  }
}
.el-cascader {
  width: 100%;
}
.el-select {
  width: 100%;
}
.el-date-editor {
  width: 100%;
}
.remarks {
  color: #d01415;
  font-size: 10px;
}
::v-deep .dif {
  .el-form-item__content {
    display: flex;
    .el-input {
      flex: 1;
      margin-right: 20px;
    }
    .el-input:last-child {
      margin-right: 0;
    }
  }
}
.pitch_on {
  border: 1px solid #ff2c2c;
  padding: 6px 12px;
  box-sizing: border-box;
  margin: 12px 0;
}
.edit_box {
  position: relative;
  .edit_button {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 9;
  }
}
.form_wrap {
  padding-left: 30px;
  padding-right: 30px;
}
.line1 {
  width: 100%;
  height: 45px;
  border-bottom: 2px solid #1169e9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .line1_left {
    width: 171px;
    height: 45px;
    line-height: 45px;
    background-image: url("~@/assets/tms/detail.png");
    background-size: 171px 45px;
    color: #ffffff;
    font-weight: 600;
    font-size: 14px;
    padding-left: 54px;
  }
  .line1_right {
    width: 99px;
    height: 36px;
    background: #1169e9;
    border-radius: 3px 3px 3px 3px;
    text-align: center;
    line-height: 36px;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
.card_type_title {
  font-size: 19px;
  font-weight: bold;
  margin-left: 30px;
  margin-bottom: 20px;
}
::v-deep .el-tooltip__popper.is-dark {
  background-color: rgba(0, 0, 0, 0.8);
  padding: 8px 12px;
  border-radius: 4px;
}
</style>
/* eslint-enable no-console */
